export default __webpack_public_path__ + "static/media/logo-v2.a6970403.png";